import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, {
    type: _ctx.useConfig.type,
    size: _ctx.pageType,
    class: _normalizeClass(_ctx.useConfig.className)
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.useConfig.text), 1)
    ]),
    _: 1
  }, 8, ["type", "size", "class"]))
}